import {
  selectConceptGroups,
  useCohortDefinitionStore,
} from '@verantos-dev/app-state-cohort-definition';
import { useConceptGroups } from '@verantos-dev/data-access-concept-groups';
import {
  selectAVById,
  selectCriteriaSelectionByAVId,
  selectIsIndexDateAV,
  toConceptGroupOptions,
} from '@verantos-dev/feature-analytical-variables';
import { CohortBuilderItemStatus } from '@verantos-dev/types-cohorts';

import {
  buildCriteriaStatusChips,
  INDEX_DATE_CHIPS,
} from '../../../../constants/previewChipStyles';
import { useCohortMetadata } from '../../../../hooks/common/useCohortMetadata';
import { useGetAVCriteriaStatus } from '../../cohort-builder-sections/CriteriaSection/hooks/useGetAVCriteriaStatus';

/** Resolves AV data for the edit page given an analytical variable ID. */
export const useAVEditData = (analyticalVariableId: string) => {
  const analyticalVariable = useCohortDefinitionStore(selectAVById(analyticalVariableId));
  const conceptGroups = toConceptGroupOptions(useCohortDefinitionStore(selectConceptGroups));
  const { isConceptGroupsLoading } = useConceptGroups();
  const { cohortOwner, cohortLastModified } = useCohortMetadata();
  const criteriaSelection = useCohortDefinitionStore(
    selectCriteriaSelectionByAVId(analyticalVariableId)
  );
  const isIndexDate = useCohortDefinitionStore(selectIsIndexDateAV(analyticalVariableId));
  const { getStatus, getErrorCount } = useGetAVCriteriaStatus();
  const avStatus = getStatus(analyticalVariableId);
  const hasError = avStatus.includes(CohortBuilderItemStatus.ERROR);
  const hasWarning = avStatus.includes(CohortBuilderItemStatus.WARNING);
  const errorCount = getErrorCount(analyticalVariableId);
  const statusChips = isIndexDate ? INDEX_DATE_CHIPS : buildCriteriaStatusChips(criteriaSelection);

  return {
    analyticalVariable,
    conceptGroups,
    isConceptGroupsLoading,
    statusChips,
    hasError,
    hasWarning,
    errorCount,
    cohortOwner,
    cohortLastModified,
  };
};
